import { render, staticRenderFns } from "./OrdersScheduled.vue?vue&type=template&id=986bc0d0&scoped=true&"
import script from "./OrdersScheduled.vue?vue&type=script&lang=js&"
export * from "./OrdersScheduled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986bc0d0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('986bc0d0')) {
      api.createRecord('986bc0d0', component.options)
    } else {
      api.reload('986bc0d0', component.options)
    }
    module.hot.accept("./OrdersScheduled.vue?vue&type=template&id=986bc0d0&scoped=true&", function () {
      api.rerender('986bc0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/OrdersScheduled.vue"
export default component.exports